<template>
  <!-- Main content -->
  <section class="content">
    <!-- Info boxes -->
    <div class="row dashboard-content">
      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="row">
          <div class="info-box">
            <span class="info-box-icon box-orange"><i class="ion ion-ios-paper-outline"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">Testimonies</span>
              <span class="info-box-number">{{total}}</span>
              <!-- <span class="info-box-sub-text">(last 24 hours)</span> -->
            </div>
            <!-- /.info-box-content -->
          </div>
          <!-- /.info-box -->
        </div>

        <div class="row">
          <div class="info-box">
            <span class="info-box-icon box-orange"><i class="ion ion-ios-filing-outline"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">Cases</span>
              <span class="info-box-number">{{cases}}</span>
            </div>
            <!-- /.info-box-content -->
          </div>
          <!-- /.info-box -->
        </div>

        <div class="row">
          <div class="info-box box-orange info-box-with-progress">
            <span class="info-box-icon"><i class="ion ion-social-buffer-outline"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">Cases completed</span>
              <span class="info-box-number">{{casesCompletedRatio}}<small>%</small></span>

              <div class="progress">
                <div class="progress-bar" v-bind:style="'width:'+ casesCompletedRatio +'%'"></div>
              </div>
                  <!-- <span class="progress-description">
                    50% Increase
                  </span> -->
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>

        <!-- 
          <div class="row">
          <tweet v-for="tweet in tweets" :key="tweet.id" :id="tweet.id" :options="{ cards: 'hidden' }"></tweet>
        </div>
        -->
      </div>

      <!-- Main row -->
      <div class="col-md-9 col-sm-6 col-xs-12">
        <div class="box box-wwow">
          <div class="box-header with-border">
              <h3 class="box-title"></h3>
              <div class="box-body">
                <div class="row">
                  <div class="col-sm-6 col-xs-12">
                    <p class="text-center">
                      <strong>Monthly Testimonies Overview</strong>
                    </p>
                    <canvas id="trafficBar" ></canvas>
                  </div>
                  <hr class="visible-xs-block">
                  <div class="col-sm-6 col-xs-12">
                    <p class="text-center">
                      <strong>Testimonies Gender Repartition</strong>
                    </p>
                    <canvas id="genderRepartition"></canvas>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-xs-12 top-space">
                    <p class="text-center">
                      <strong>Worldwild Testimonies Localisation</strong>
                    </p>
                    <div id="world-map-markers"></div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /.content -->
</template>

<script>
import Chart from 'chart.js'
import moment from 'moment'
import api from '../../api'
import _ from 'lodash'

const pluginURL = '/static/js/plugins/jvectormap/jquery-jvectormap-2.0.3.min.js'
const mapURL = '/static/js/plugins/jvectormap/jquery-jvectormap-world-mill.js'

export default {
  data () {
    return {
      generateRandomNumbers (numbers, max, min) {
        var a = []
        for (var i = 0; i < numbers; i++) {
          a.push(Math.floor(Math.random() * (max - min + 1)) + max)
        }
        return a
      },
      tweets: [],
      total: null,
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      testimoniesByMonthValues: [],
      testimoniesByGenderValues: [0, 0], // [MALE, FEMALE]
      cases: null,
      casesCompletedRatio: null,
      markers: []
    }
  },
  methods: {
    onMarkerClick (e, code) {
      if (this.markers[code] && this.markers[code].id) {
        this.$router.push({name: 'Testimony', params: { id: this.markers[code].id }})
      }
    },
    getTweets () {
      this.tweets = [
        { id: '955173521138823169' },
        { id: '955031868373549056' },
        { id: '954244683630284801' }
      ]
    },
    makeMap () {
      window.jQuery.getScript(pluginURL, () => {
        window.jQuery.getScript(mapURL, () => {
          window.jQuery('#world-map-markers').vectorMap({
            map: 'world_mill',
            regionStyle: {
              initial: {
                fill: 'white',
                'fill-opacity': 1,
                stroke: 'rgb(80,80,80)',
                'stroke-width': 0.5,
                'stroke-opacity': 0.5
              },
              hover: {
                'fill-opacity': 0.8,
                cursor: 'pointer'
              },
              selected: {
                fill: 'yellow'
              },
              selectedHover: {
              }
            },
            backgroundColor: 'transparent',
            zoomOnScroll: false,
            scaleColors: ['#C8EEFF', '#0071A4'],
            normalizeFunction: 'polynomial',
            markerStyle: {
              initial: {
                fill: '#E14253',
                stroke: '#b43442'
              },
              hover: {
                stroke: '#747B83',
                'stroke-width': 1,
                cursor: 'pointer',
                'fill-opacity': 0.8
              }
            },
            markerLabelStyle: {
              initial: {
                'font-family': 'Verdana',
                'font-size': '12',
                'font-weight': 'bold',
                cursor: 'default',
                fill: 'black'
              },
              hover: {
                cursor: 'pointer'
              }
            },
            markers: this.markers,
            onMarkerClick: this.onMarkerClick
          })
        })
      })
    },
    getMarkers () {
      /* Making API call to authenticate a user */
      api.authenticatedRequest('get', `/testimonies?size=100&sortField=creationDate&desc=true`)
      .then(response => {
        const data = response.data
        this.markers = data.data.filter((testimony) => {
          return testimony && testimony.victimLocation && testimony.victimLocation.geoLocation &&
            testimony.victimLocation.geoLocation.coordinates && testimony.victimLocation.geoLocation.coordinates.length === 2
        }).map((testimony) => {
          return {
            latLng: [testimony.victimLocation.geoLocation.coordinates[1], testimony.victimLocation.geoLocation.coordinates[0]],
            name: testimony.actionDetail.actionLocation.zone,
            id: testimony._id
          }
        })

        const testimoniesByMonth = _.groupBy(data.data.filter(testimony => testimony.creationDate != null),
        testimony => moment(testimony.creationDate).format('MMM'))
        for (var prop in testimoniesByMonth) {
          if (Object.prototype.hasOwnProperty.call(testimoniesByMonth, prop)) {
            testimoniesByMonth[prop] = testimoniesByMonth[prop].length
          }
        }
        this.months.forEach((key, index) => {
          Object.keys(testimoniesByMonth).includes(key) ? this.testimoniesByMonthValues.push(testimoniesByMonth[key]) : this.testimoniesByMonthValues.push(0)
        })

        const testimoniesGender = _.groupBy(data.data.filter(testimony => testimony.victimIdentity.gender === 'MALE' || testimony.victimIdentity.gender === 'FEMALE'),
        testimony => testimony.victimIdentity.gender)
        for (var prop2 in testimoniesGender) {
          if (Object.prototype.hasOwnProperty.call(testimoniesGender, prop2)) {
            testimoniesGender[prop2] = testimoniesGender[prop2].length
          }
        }

        const summ = (testimoniesGender['MALE'] ? testimoniesGender['MALE'] : 0) + (testimoniesGender['FEMALE'] ? testimoniesGender['FEMALE'] : 0)
        testimoniesGender['MALE'] ? this.testimoniesByGenderValues[0] = (testimoniesGender['MALE'] * 100) / summ : null
        testimoniesGender['FEMALE'] ? this.testimoniesByGenderValues[1] = (testimoniesGender['FEMALE'] * 100) / summ : null

        this.makeMap()
        this.total = data.total
      })
      .catch(error => {
        console.log(error)
        if (error.response.status === 401) { // InvalidCredentialsError
          this.response = 'Username/Password incorrect. Please try again.'
          return
        }
        this.response = 'Server appears to be offline'
      })
    },
    getCases () {
      /* Making API call to authenticate a user */
      api.authenticatedRequest('get', `/cases?size=10&sortField=creationDate&desc=true`)
      .then(response => {
        const data = response.data
        this.cases = data.total
        var casesCompleted = data.data.filter(c => {
          c.status === 'COMPLETED'
        }).length

        if (this.cases !== 0) {
          this.casesCompletedRatio = Math.ceil(casesCompleted / data.total * 100)
        } else {
          this.casesCompletedRatio = 0
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response.status === 401) { // InvalidCredentialsError
          this.response = 'Username/Password incorrect. Please try again.'
          return
        }
        this.response = 'Server appears to be offline'
      })
    }
  },
  computed: {
    coPilotNumbers () {
      return this.generateRandomNumbers(12, 100, 2)
    },
    personalNumbers () {
      return this.generateRandomNumbers(12, 1000000, 10000)
    },
    isMobile () {
      return window.innerWidth <= 800 && window.innerHeight <= 600
    }
  },
  mounted () {
    this.getMarkers()
    const monthValues = this.testimoniesByMonthValues
    const genderValues = this.testimoniesByGenderValues
    this.$nextTick(() => {
      // var ctx = document.getElementById('monthlyTestimoniesBar').getContext('2d')
      var ctx = document.getElementById('trafficBar').getContext('2d')
      var config = {
        type: 'bar',
        data: {
          labels: this.months,
          datasets: [
            {
              label: 'Testimonies',
              backgroundColor: '#E14253',
              borderColor: '#E14253',
              borderWidth: 2,
              data: monthValues
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: !this.isMobile,
          legend: {
            position: 'bottom',
            display: true
          },
          tooltips: {
            mode: 'label',
            xPadding: 10,
            yPadding: 10,
            bodySpacing: 10
          }
        }
      }

      new Chart(ctx, config) // eslint-disable-line no-new

      var pieChartCanvas = document
        .getElementById('genderRepartition')
        .getContext('2d')
      var pieConfig = {
        type: 'pie',
        data: {
          labels: ['Men', 'Women'],
          datasets: [
            {
              data: genderValues,
              backgroundColor: ['#E14253', '#af242a'],
              hoverBackgroundColor: ['#E14253', '#af242a']
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: !this.isMobile,
          legend: {
            position: 'bottom',
            display: true
          }
        }
      }
      new Chart(pieChartCanvas, pieConfig) // eslint-disable-line no-new
      this.getTweets()
      this.getCases()
    })
  }
}
</script>
<style>
.dashboard-content {
  padding: 0 12px;
}
.info-box {
  cursor: pointer;
}
.fullCanvas {
  width: 100%;
}
#world-map-markers svg {
  height: 420px;
}
.top-space {
  margin-top: 60px;
}

.Tweet-text {
  font-size: 14px !important;
}

.Tweet-actions {
  display: none !important;
}

.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
  height: 90px;
  justify-content: center;
  display: flex;
  flex-direction: column;
  color: #444;
}

.info-box-text {
  font-size: 18px;
  font-weight: 500;
  font-family: "Raleway", sans-serif;
}

.info-box-sub-text {
  font-size: 13px;
  color: #747B83;
  font-family: "Raleway", sans-serif;
}

.info-box-number {
  font-size: 24px;
}

.info-box-with-progress.box-orange {
  background-color: #af242a !important;
  color: #fff !important;
}

.info-box-with-progress .info-box-icon {
  background: transparent;
  color: #fff;
}

.info-box-with-progress .info-box-content {
  background: #fff;
  color: #444;
}

.info-box-with-progress .progress-bar {
  background: #e14253 !important;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?42f7bac0